import { Button, Drawer, Grid } from "@mui/material";
import styled from "styled-components";
import { deviceSpec } from "breakpoints";

export const SearchAndStatusBarGrid = styled(Grid)`
  margin-top: 1em;
  
  @media ${deviceSpec.isMobile} {
    margin-top: 0px;
  }
`;

export const DataTableGrid = styled(Grid)`
  margin-top: 10px;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
  border-top: 1px solid rgba(255, 255, 255, 0.5);
`

export const DrawerStyled = styled(Drawer)`
  > .MuiPaper-root {
    width: 50%;
    background-color: ${({ theme }) => theme.colors.historyBg};
  }

  // @media ${deviceSpec.isLaptop} {
  //   > .MuiPaper-root {
  //     width: 100%;
  //   }
  // }

  @media ${deviceSpec.isTablet} {
    > .MuiPaper-root {
      width: 100%;
    }
  }

  @media ${deviceSpec.isMobile} {
    > .MuiPaper-root {
      width: 100%;
    }
  }
`

export const ChatBotContainer = styled("div")`
`

export const IncidentsToolBarGrid = styled(Grid)`
  margin-top: 0.5rem;
  display: flex;
  justify-content: space-between;

  @media ${deviceSpec.isMobile} {
    margin-top: 0px;
    margin-bottom: 15px;
    flex-direction: column !important;

    .MuiGrid-item {
      flex-direction: column !important;

      .MuiGrid-item {
        margin: 0;
      }

      button {
        align-self: start;
        align-items: center;
        margin: 0 8px;
      }

      button:nth-child(2) {
        margin: 8px;
      }

      button:nth-child(1) {
        margin-top: 8px;
      }
    }
  }
`;

export const FilterButton = styled(Button)`
  height: 36px;
  align-self: center;
  border-radius: 2rem !important;
  border: 1px solid ${({ theme }) => theme.colors.buttonBorder} !important;
  gap: 8px;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  background-color: ${({ theme }) => theme.name === "light-theme" ? theme.colors.white : theme.colors.buttonBackground} !important;
  color: ${({ theme }) => theme.colors.textColor} !important;
  
  &:hover {
    border-color: ${({ theme }) => theme.colors.buttonBorderHighlight} !important;
    background-color: ${({ theme }) => theme.name === "light-theme" ? theme.colors.buttonHover : "rgba(52, 195, 255, 0.1)"} !important;
  }
`;

export const FilterTitle = styled("p")`
  width: max-content;
`;

export const FiltersAppliedBadge = styled("span")`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.name === "light-theme" ? theme.colors.buttonBackground : theme.colors.highlight2};
  color: ${({ theme }) => theme.colors.white};
  margin-left: 4px;
  
  & > p {
    width: max-content;
    margin: 0;
    font-size: 12px;
    font-weight: 500;
  }
`

export const BadgeCount = styled("p")`
  align-self: center;
  padding: 0;
  line-height: 1;
`

export const ExportBtn = styled(Button)({
  height: "30px",
  "&.MuiButton-root": {
    border: "1px solid white",
  },
  gap: 11,
});

export const CardListViewBtn = styled(Button)<{ selected: boolean }>(
  ({ selected }: { selected: boolean }) => ({
    "&.MuiButton-root": {
      background: selected ? "#AF24FF" : "transparent",
      border: "1px solid white",
      padding: "0px 6px",
      minWidth: "0px",
      height: "30px",
    },
  })
);

export const IncidentsToolbarLeftGrid = styled(Grid)`
  gap: 8.55px;
`;

export const IncidentsToolbarRightGrid = styled(Grid)({
  display: "flex",
  justifyContent: "flex-end",
  gap: "8.55px",
});

export const CalendarBtn = styled(Button)({
  "&.MuiButton-root": {
    border: "0.808989px solid #76766b",
    height: "42px",
    alignSelf: "center",
    gap: 12,
    borderBottomRightRadius: "unset",
    borderTopRightRadius: "unset",
  },
});


export const TabletMobileToolBar = styled('div')`
  .component-hidden {
    transform: translateY(-20px) scale(0.95);
    display: none;
  }

  .component-visible {
    padding: 1em;
    transform: translateY(0) scale(1);
    transition: opacity 0.4s ease-out, transform 0.4s ease-out;
    width: 100%;

    @media ${deviceSpec.isDesktop} {
        display: none;
    }

    @media ${deviceSpec.isLaptop} {
        display: none;
    }

    @media ${deviceSpec.isTablet} {
      display: block;
    }
  }
`

export const DesktopToolBar = styled('div')`
  @media ${deviceSpec.isTablet} {
    display: none;
  }

  @media ${deviceSpec.isMobile} {
    display: none;
  }
`